// @flow
import styled from "styled-components";
import { Link } from "react-router-dom";

import colors from "../../assets/css/colors";

export const ButtonSecondary = styled.button`
	outline: none;
	border: 1px solid ${colors.nrlDarkGreen};
	background: transparent;
	color: ${colors.nrlDarkGreen};
	border-radius: 3px;
	font-weight: bold;
	font-size: 12px;
	letter-spacing: 0.5px;
	line-height: 1.2;
	padding: 10px;
	cursor: pointer;
	width: ${({ width }) => width || 'auto'};
	text-transform: uppercase;
	text-align: center;

	&:hover {
		border: 1px solid ${colors.nrlDarkGreenHover};
		color: ${colors.nrlDarkGreenHover};
	}

	&:disabled {
		background: ${colors.lightGreen};
		color: #fff;
		border-color: ${colors.lightGreen};
	}
`;

ButtonSecondary.displayName = "ButtonSecondary";

export const ButtonSecondaryLink = styled(ButtonSecondary.withComponent(Link))`
	display: flex;
	align-items: center;
    justify-content: center;
	text-decoration: none;
`;

ButtonSecondaryLink.displayName = "ButtonSecondaryLink";

export default ButtonSecondary;


// WEBPACK FOOTER //
// ./src/components/ButtonSecondary/index.js